import React from "react";
import { useAuth } from "../../context/AuthContext";

const Header = ({ setSidebarOpen }) => {
  const { user } = useAuth();
  return (
    <>
      {/* Custom breakpoint */}
      <style jsx>{`
        @media (min-width: 1285px) {
          .custom-xl\\:hidden {
            display: none !important;
          }
        }
      `}</style>
      <header className="custom-xl:hidden sticky top-0 z-20 bg-white/85 backdrop-blur-md border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-4 py-4 sm:py-5">
            {/* Mobile menu button */}
            <button
              onClick={() => setSidebarOpen(true)}
              className="p-2"
              aria-label="Open sidebar"
            >
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="3" y1="5" x2="21" y2="5" />
                <circle cx="14" cy="5" r="3" fill="black" />
                <line x1="3" y1="12" x2="21" y2="12" />
                <circle cx="8" cy="12" r="3" fill="black" />
                <line x1="3" y1="19" x2="21" y2="19" />
                <circle cx="17" cy="19" r="3" fill="black" />
              </svg>
            </button>

            {/* Title */}
            <div className="flex flex-col">
              <h1 className="text-lg sm:text-xl lg:text-2xl font-semibold tracking-tight bg-gradient-to-r text-black bg-clip-text">
                Customize Your Feed
              </h1>
              <p className="text-sm text-gray-500 leading-tight mt-0.5">
                Pick a category to see posts from the creators you follow
              </p>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;